import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './common/components/page-not-found/page-not-found.component';
import { JoinViaCreditUpClub } from './join-via-creditupclub/join-via-creditupclub.component';
import { SiteMaintenanceComponent } from './site-maintenance/site-maintenance.component';


export const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: 'coming-soon', component: SiteMaintenanceComponent },
    { path: 'auth', loadChildren: 'app/login/login.module#LoginModule' },
    { path: 'signup', loadChildren: 'app/sign-up/sign-up.module#SignUpModule' },
    { path: 'home', loadChildren: 'app/home/home.module#HomeModule', data: { preload: true } },
    { path:'jointheclub',loadChildren:'app/creditup-club/creditup-club.module#CreditupClubModule'},
    { path:'join-via-creditupclub', component: JoinViaCreditUpClub},
    { path: '**', component: PageNotFoundComponent }
];
// export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/app-routing.module.ts